
if ('undefined' === typeof app_meta) {
    throw new Error("App meta is not defined!");
}

export const wp_rest_baseurl = app_meta.rest_baseurl;

export const wp_rest_api_nonce = app_meta.rest_nonce;